module.exports = __webpack_public_path__ + "img/strikethrough-02.7800c781.svg";